import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const Afiliados = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/afiliado/new' || path.indexOf('/afiliado/edit') === 0) && <Formulario {...props}/>}
            {path === '/afiliado/list' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default Afiliados;
